"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCategory = exports.EXCLUDE_USA = exports.AD_VOUCHER_75_GEOS = exports.CREDIT_CARD_RATES_EU_GEOS = exports.AVALARA_EXCLUDED_GEOS = exports.Country = exports.Language = exports.Vertical = exports.PlanType = exports.ProductFamily = exports.ProductCode = void 0;
var ProductCode;
(function (ProductCode) {
    ProductCode["WEBSITE_COMBO"] = "website_combo";
    ProductCode["WEBSITE_CONNECT_DOMAIN"] = "website_connect_domain";
    ProductCode["WEBSITE_UNLIMITED"] = "website_unlimited";
    ProductCode["WEBSITE_PRO"] = "website_pro";
    ProductCode["WEBSITE_VIP"] = "website_vip";
    ProductCode["BUSINESS_BASIC"] = "business_basic";
    ProductCode["BUSINESS_UNLIMITED"] = "business_unlimited";
    ProductCode["BUSINESS_VIP"] = "business_vip";
    ProductCode["BUSINESS_ENTERPRISE"] = "business_enterprise";
    ProductCode["BUSINESS_GROW"] = "business_grow";
    ProductCode["BUSINESS_SELL"] = "business_sell";
    ProductCode["BUSINESS_EVOLVE"] = "business_evolve";
    ProductCode["OLD_PRODUCT"] = "old_product";
    ProductCode["WEBSITE_ESSENTIAL"] = "website_essential";
    ProductCode["WEBSITE_EXTRA"] = "website_extra";
    ProductCode["WEBSITE_ULTRA"] = "website_ultra";
    ProductCode["BUSINESS_LAUNCH"] = "business_launch";
    ProductCode["BUSINESS_BOOST"] = "business_boost";
    ProductCode["BUSINESS_SCALE"] = "business_scale";
    ProductCode["WEBSITE_LITE"] = "website_lite";
    ProductCode["DAYFUL_FREE"] = "dayful_free";
    ProductCode["DAYFUL_BASIC"] = "dayful_basic";
    ProductCode["DAYFUL_STANDARD"] = "dayful_standard";
    ProductCode["DAYFUL_ADVANCED"] = "dayful_advanced";
    ProductCode["LIGHT"] = "light";
    ProductCode["CORE"] = "core";
    ProductCode["BUSINESS"] = "business";
    ProductCode["BUSINESS_ELITE"] = "business_elite";
    ProductCode["ENTERPRISE"] = "enterprise";
    ProductCode["STUDIO_BASIC"] = "studio_basic";
    ProductCode["STUDIO_STANDARD"] = "studio_standard";
    ProductCode["STUDIO_PLUS"] = "studio_plus";
    ProductCode["STUDIO_ELITE"] = "studio_elite";
})(ProductCode = exports.ProductCode || (exports.ProductCode = {}));
var ProductFamily;
(function (ProductFamily) {
    ProductFamily["Default"] = "Default";
    ProductFamily["Pro"] = "Pro";
    ProductFamily["VIP"] = "Vip";
    ProductFamily["Unlimited"] = "Unlimited";
    ProductFamily["Enterprise"] = "Enterprise";
    ProductFamily["Vertical"] = "Vertical";
    ProductFamily["Evolve"] = "Evolve";
    ProductFamily["Grow"] = "Grow";
    ProductFamily["Sell"] = "Sell";
    ProductFamily["Combo"] = "Combo";
    ProductFamily["ConnectDomain"] = "Connect_Domain";
    ProductFamily["Essential"] = "Essential";
    ProductFamily["Extra"] = "Extra";
    ProductFamily["Ultra"] = "Ultra";
    ProductFamily["Launch"] = "Launch";
    ProductFamily["Boost"] = "Boost";
    ProductFamily["Scale"] = "Scale";
    ProductFamily["Lite"] = "Lite";
    ProductFamily["Basic"] = "Basic";
    ProductFamily["Standard"] = "Standard";
    ProductFamily["Advanced"] = "Advanced";
    ProductFamily["Dayful"] = "Dayful";
    ProductFamily["Light"] = "Light";
    ProductFamily["Core"] = "Core";
    ProductFamily["Business"] = "Business";
    ProductFamily["Elite"] = "Elite";
    ProductFamily["Plus"] = "Plus";
})(ProductFamily = exports.ProductFamily || (exports.ProductFamily = {}));
var PlanType;
(function (PlanType) {
    PlanType["Website"] = "website";
    PlanType["Business"] = "business";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
var Vertical;
(function (Vertical) {
    Vertical["Default"] = "Default";
    Vertical["Bookings"] = "Bookings";
    Vertical["Stores"] = "Stores";
    Vertical["Restaurants"] = "Restaurant-1";
    Vertical["Hotels"] = "Hotels";
    Vertical["Music"] = "Music";
    Vertical["Video"] = "Video";
    Vertical["Events"] = "Events";
    Vertical["ArtStore"] = "Art Store";
    Vertical["PaidPlans"] = "Paid Plans";
    Vertical["Fitness"] = "Fitness";
    Vertical["OnlinePrograms"] = "OnlinePrograms";
})(Vertical = exports.Vertical || (exports.Vertical = {}));
var Language;
(function (Language) {
    Language["CS"] = "cs";
    Language["DA"] = "da";
    Language["DE"] = "de";
    Language["EN"] = "en";
    Language["ES"] = "es";
    Language["FI"] = "fi";
    Language["FR"] = "fr";
    Language["HI"] = "hi";
    Language["IT"] = "it";
    Language["JA"] = "ja";
    Language["KO"] = "ko";
    Language["NL"] = "nl";
    Language["NO"] = "no";
    Language["PL"] = "pl";
    Language["PT"] = "pt";
    Language["RU"] = "ru";
    Language["SV"] = "sv";
    Language["TH"] = "th";
    Language["TR"] = "tr";
    Language["UK"] = "uk";
    Language["ZH"] = "zh";
    Language["VI"] = "vi";
    Language["ID"] = "id";
    Language["IN"] = "in";
    Language["INVALID"] = "invalid";
})(Language = exports.Language || (exports.Language = {}));
var Country;
(function (Country) {
    Country["CA"] = "CA";
    Country["USA"] = "US";
    Country["GB"] = "GB";
    Country["AU"] = "AU";
    Country["FR"] = "FR";
    Country["BR"] = "BR";
    Country["RU"] = "RU";
    Country["DE"] = "DE";
    Country["JA"] = "JP";
    Country["IN"] = "IN";
    Country["BE"] = "BE";
    Country["CH"] = "CH";
    Country["ES"] = "ES";
    Country["IE"] = "IE";
    Country["IL"] = "IL";
    Country["IT"] = "IT";
    Country["KZ"] = "KZ";
    Country["NL"] = "NL";
    Country["NO"] = "NO";
    Country["NZ"] = "NZ";
    Country["PL"] = "PL";
    Country["PT"] = "PT";
    Country["SE"] = "SE";
    Country["TR"] = "TR";
    Country["ZA"] = "ZA";
    Country["AT"] = "AT";
    Country["BY"] = "BY";
    Country["BG"] = "BG";
    Country["HR"] = "HR";
    Country["CY"] = "CY";
    Country["CZ"] = "CZ";
    Country["DK"] = "DK";
    Country["FI"] = "FI";
    Country["GR"] = "GR";
    Country["HU"] = "HU";
    Country["IS"] = "IS";
    Country["LV"] = "LV";
    Country["LT"] = "LT";
    Country["RO"] = "RO";
    Country["SA"] = "SA";
    Country["SK"] = "SK";
    Country["SI"] = "SI";
    Country["UA"] = "UA";
    Country["AE"] = "AE";
    Country["AQ"] = "AQ";
    Country["AS"] = "AS";
    Country["EH"] = "EH";
    Country["FM"] = "FM";
    Country["GU"] = "GU";
    Country["IM"] = "IM";
    Country["MH"] = "MH";
    Country["MP"] = "MP";
    Country["PR"] = "PR";
    Country["PW"] = "PW";
    Country["VI"] = "VI";
    Country["AX"] = "AX";
    Country["BV"] = "BV";
    Country["HM"] = "HM";
    Country["UM"] = "UM";
    Country["PH"] = "PH";
    Country["EE"] = "EE";
    Country["LU"] = "LU";
    Country["MT"] = "MT";
})(Country = exports.Country || (exports.Country = {}));
exports.AVALARA_EXCLUDED_GEOS = [
    Country.IN,
    Country.BR,
    Country.AQ,
    Country.AS,
    Country.EH,
    Country.FM,
    Country.GU,
    Country.IM,
    Country.MH,
    Country.MP,
    Country.PR,
    Country.PW,
    Country.VI,
    Country.AX,
    Country.BV,
    Country.HM,
    Country.UM,
];
exports.CREDIT_CARD_RATES_EU_GEOS = [
    Country.AT,
    Country.BE,
    Country.FI,
    Country.DE,
    Country.IE,
    Country.IT,
    Country.LT,
    Country.NL,
    Country.PT,
    Country.ES,
];
exports.AD_VOUCHER_75_GEOS = [
    Country.AU,
    Country.BE,
    Country.CH,
    Country.DE,
    Country.ES,
    Country.FR,
    Country.IE,
    Country.IL,
    Country.IT,
    Country.KZ,
    Country.NL,
    Country.NO,
    Country.NZ,
    Country.PL,
    Country.PT,
    Country.SE,
    Country.TR,
    Country.ZA,
    Country.AT,
    Country.BG,
    Country.HR,
    Country.CY,
    Country.CZ,
    Country.DK,
    Country.FI,
    Country.GR,
    Country.HU,
    Country.IS,
    Country.LV,
    Country.LT,
    Country.RO,
    Country.SA,
    Country.SK,
    Country.SI,
    Country.AE,
];
exports.EXCLUDE_USA = [
    Country.CA,
    Country.GB,
    Country.AU,
    Country.FR,
    Country.BR,
    Country.RU,
    Country.DE,
    Country.JA,
    Country.IN,
    Country.BE,
    Country.CH,
    Country.ES,
    Country.IE,
    Country.IL,
    Country.IT,
    Country.KZ,
    Country.NL,
    Country.NO,
    Country.NZ,
    Country.PL,
    Country.PT,
    Country.SE,
    Country.TR,
    Country.ZA,
    Country.AT,
    Country.BY,
    Country.BG,
    Country.HR,
    Country.CY,
    Country.CZ,
    Country.DK,
    Country.FI,
    Country.GR,
    Country.HU,
    Country.IS,
    Country.LV,
    Country.LT,
    Country.RO,
    Country.SA,
    Country.SK,
    Country.SI,
    Country.UA,
    Country.AE,
    Country.AQ,
    Country.AS,
    Country.EH,
    Country.FM,
    Country.GU,
    Country.IM,
    Country.MH,
    Country.MP,
    Country.PR,
    Country.PW,
    Country.VI,
    Country.AX,
    Country.BV,
    Country.HM,
    Country.UM,
    Country.PH,
];
var SectionCategory;
(function (SectionCategory) {
    SectionCategory["DEVELOPER"] = "DEVELOPER";
    SectionCategory["COMPLETE_ECOMMERCE_PLATFORM"] = "COMPLETE_ECOMMERCE_PLATFORM";
    SectionCategory["ONLINE_BOOKINGS_CALENDAR"] = "ONLINE_BOOKINGS_CALENDAR";
    SectionCategory["TICKETS_EVENT_MANAGEMENT"] = "TICKETS_EVENT_MANAGEMENT";
    SectionCategory["MONETIZE_YOUR_ART_CONTENT"] = "MONETIZE_YOUR_ART_CONTENT";
    SectionCategory["TAKE_ONLINE_ORDERS"] = "TAKE_ONLINE_ORDERS";
    SectionCategory["MANAGE_HOTEL_RESERVATIONS"] = "MANAGE_HOTEL_RESERVATIONS";
    SectionCategory["MARKETING_SUITE"] = "MARKETING_SUITE";
    SectionCategory["COMPLETE_SOLUTION_FOR_FITNESS_PROS"] = "COMPLETE_SOLUTION_FOR_FITNESS_PROS";
    SectionCategory["ONLINE_PROGRAMS"] = "ONLINE_PROGRAMS";
})(SectionCategory = exports.SectionCategory || (exports.SectionCategory = {}));
//# sourceMappingURL=enums.js.map